import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import Form from '../forms/Form';
import { isNovertejumsEditableByUser } from './riskaNovertejumsUtils';
import {
    loadRiskaNovertejums,
    riskaNovertejumuPamatinfoActions
} from '../../actions/dzeramaUdensSatecesBaseiniActions';

const sledzienFormFieldCfgs = [
    {
        name: 'sledziens',
        label: 'Eksperta slēdziens',
        type: 'textarea',
        extraFieldProps: { rows: 12 }
    }
];

class RiskaNovertejumsSledziens extends Component {

    handleSave = (data) => {
        const { savePamatinfoAct, loadRiskaNovertejums, id } = this.props;
        const { parametri, geom, urbumi_snapshot, riska_objekti, ...dataToSave } = data;
        return savePamatinfoAct(dataToSave).then((result) => {
            loadRiskaNovertejums(id);
            return result;
        });
    }

    render() {
        const { novertejums, riskaNovertejumiPamatinfo } = this.props;

        if (!novertejums) {
            return <Alert color="info">Nav datu</Alert>;
        }

        const { editable, submiting } = riskaNovertejumiPamatinfo || {};
        const isEditable = isNovertejumsEditableByUser(novertejums, this.props.user?.tiesibas);

        return (
            <div className="form-container">
                {!isEditable && !novertejums.sledziens ? (
                    <Alert color="info">Slēdziens netika pievienots</Alert>
                ) : (
                    <Form
                        editable={editable}
                        submiting={submiting}
                        dataObj={novertejums}
                        formFieldCfgs={sledzienFormFieldCfgs}
                        metadataFormCfg="riska_novertejumi_pamatinfo_view"
                        onSubmit={this.handleSave}
                        onReset={this.props.stopEditPamatinfoAct}
                        onStartEdit={isEditable ? this.props.startEditPamatinfoAct : null}
                        tiesibasLabot="SATECES_BASEINI_VERTETAJS"
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    novertejums: (state.riskaNovertejumi || {}).selectedItem,
    riskaNovertejumiPamatinfo: state.riskaNovertejumiPamatinfo || {},
    user: state.user || {}
});

export default connect(mapStateToProps, {
    savePamatinfoAct: riskaNovertejumuPamatinfoActions.saveAct,
    startEditPamatinfoAct: riskaNovertejumuPamatinfoActions.startEditAct,
    stopEditPamatinfoAct: riskaNovertejumuPamatinfoActions.stopEditAct,
    loadRiskaNovertejums
})(RiskaNovertejumsSledziens);
